import { useState, useRef, useContext } from 'react';
import { IconButton, Popover, List, ListItem, ListItemText, Tooltip, Box, styled } from '@mui/material';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import NightsStayIcon from '@mui/icons-material/NightsStay';
import { ThemeContext } from 'src/shared/theme/ThemeProvider';

export const ThemeSelector = () => {
  const { themeName, setThemeName } = useContext(ThemeContext);
  const [isOpen, setOpen] = useState(false);
  const ref = useRef(null);
  const themes = [
    { id: 0, title: 'Light', icon: WbSunnyIcon, themeName: 'GreyGooseTheme' },
    { id: 1, title: 'Dark', icon: NightsStayIcon, themeName: 'DarkTheme' }
  ];
  const handleThemeChange = (nextThemeName: string) => {
    setThemeName(nextThemeName); // writes to settings.theme
    setOpen(false);
  };
  const CurrentThemeIcon = themes.find((t) => t.themeName === themeName)?.icon || WbSunnyIcon;

  return (
    <>
      <Tooltip arrow title="Select Theme">
        <IconButtonWrapper ref={ref} onClick={() => setOpen(true)}>
          <CurrentThemeIcon />
        </IconButtonWrapper>
      </Tooltip>
      <Popover disableScrollLock anchorEl={ref.current} onClose={() => setOpen(false)} open={isOpen} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Box sx={{ maxWidth: 240 }}>
          <List sx={{ p: 0, svg: { width: 26, mr: 1 } }} component="nav">
            {themes.map((themeOption) => {
              const ThemeIcon = themeOption.icon;

              return (
                <ListItem key={themeOption.id} onClick={() => handleThemeChange(themeOption.themeName)}>
                  <ThemeIcon titleAccess={themeOption.title} />
                  <ListItemText sx={{ pl: 1 }} primary={themeOption.title} />
                </ListItem>
              );
            })}
          </List>
        </Box>
      </Popover>
    </>
  );
};

const IconButtonWrapper = styled(IconButton)(
  ({ theme }) => `
    width: ${theme.spacing(7)};
    height: ${theme.spacing(5)};
    svg {
      width: 30px;
    }
  `
);

export default ThemeSelector;
